import { render, staticRenderFns } from "./CustomerTeamsModal.vue?vue&type=template&id=ade63e2c&scoped=true"
import script from "./CustomerTeamsModal.vue?vue&type=script&lang=js"
export * from "./CustomerTeamsModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerTeamsModal.vue?vue&type=style&index=0&id=ade63e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade63e2c",
  null
  
)

export default component.exports